import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import {} from 'react';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import { cn } from '../lib/utils.js';
/**
 * TooltipProvider — mount once near the app root to share hover-open delay and
 * the "skip delay when moving between tooltips" behaviour across all tooltips.
 */
export function TooltipProvider({ delayDuration = 200, skipDelayDuration = 300, ...props }) {
    return (_jsx(TooltipPrimitive.Provider, { delayDuration: delayDuration, skipDelayDuration: skipDelayDuration, ...props }));
}
/**
 * Tooltip — convenience wrapper over Radix Tooltip: trigger (`asChild`) + a
 * themed content bubble. Self-contained (includes its own Provider) so it works
 * anywhere; wrap the app in `TooltipProvider` too if you want shared delay config.
 */
export function Tooltip({ content, children, side = 'top', align = 'center', sideOffset = 6, contentClassName, delayDuration, ...root }) {
    return (_jsx(TooltipPrimitive.Provider, { delayDuration: delayDuration ?? 200, children: _jsxs(TooltipPrimitive.Root, { delayDuration: delayDuration, ...root, children: [_jsx(TooltipPrimitive.Trigger, { asChild: true, children: children }), _jsx(TooltipPrimitive.Portal, { children: _jsxs(TooltipPrimitive.Content, { side: side, align: align, sideOffset: sideOffset, className: cn('z-[120] max-w-[260px] rounded-lg bg-ink px-2.5 py-1.5 font-ui text-xs font-medium leading-[1.45] text-surface shadow-card', contentClassName), children: [content, _jsx(TooltipPrimitive.Arrow, { className: "fill-ink" })] }) })] }) }));
}
//# sourceMappingURL=tooltip.js.map